import { type } from '../../utils/index.js';
const num2rgb = num => {
  if (type(num) == 'number' && num >= 0 && num <= 0xffffff) {
    const r = num >> 16;
    const g = num >> 8 & 0xff;
    const b = num & 0xff;
    return [r, g, b, 1];
  }
  throw new Error('unknown num color: ' + num);
};
export default num2rgb;